import React from "react";
import { useLoading } from "../../context/axios";
import Loader from "../Loader";

const LoadingSpinner = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return <Loader showLogo={false} transparent />;
};

export default LoadingSpinner;
